<template>
  <el-container class="index-box">
    <el-header v-show="this.$router.history.current.name!=='GetPhoneNumber'">
      <headers/>
    </el-header>
    <el-container>
      <el-aside width="asideWidth" v-show="this.$router.history.current.name!=='GetPhoneNumber' && this.$router.history.current.name!=='DataUpload'">
        <menus :isCollapse="isCollapse"/>
      </el-aside>
      <el-main style="padding:0">
        <el-container style="height: 100%">
          <el-header style="padding: 0;height:auto">
            <div style="width: 100%;border-bottom: 1px solid #E8E8E8;display: flex; align-items: center; justify-content: space-between;">
              <div v-if="isTips"
                style="line-height: 1.25em;text-align: left;font-size: 10px;padding:0;font-family: 微软雅黑;font-weight: 0;color: #909399;margin-top: 10px;margin-left:20px">
                <div :key="index" v-for="(t,index) in tipsMsg">
                  <div v-html="t"/>
                  <br>
                </div>
              </div>
              <div style="margin-right: 20px" v-if="toTrainingButton">
                <el-button class="orangev-btn" size="medium" type="primary" @click="openToTraining">通路活动-渠道激励</el-button>
              </div>
            </div>
          </el-header>
          <el-main style="padding: 0">
            <router-view v-if="isRouterAlive"/>
          </el-main>
        </el-container>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import Menus from '@/components/menus/menus'
import Headers from '@/components/header/header'

export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  components: {
    Menus,
    Headers
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    openToTraining () {
        this.$store.commit('openToTrainingDialog',true)
    }
  },
  computed: {
    isCollapse() {
      return this.$store.state.isCollapse
    },
    asideWidth() {
      return this.$store.state.isCollapse ? 'auto' : '200px'
    },
    isTips() {
      return this.$store.state.tips.isTips
    },
    tipsMsg() {
      return this.$store.state.tips.msg
    },
    toTrainingButton() {
      return this.$store.state.toTrainingButton
    }
  }
}
</script>

<style lang="scss">
.index-box {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;

  .el-container {
    height: 92%;

    .el-main {
      height: 100%;
      background-color: #fafafa;
    }
  }

  .el-aside {
    /*background-color: #20222A;*/
    height: 100%;
    /*min-height: 100%;*/
    .logo {
      /*background-color: #C0C0C0;*/
      /*color: rgba(255,255,255,.8);*/
      height: 8vh;
      text-align: center;
      padding-top: 16px;
      font-size: 16px;
      box-sizing: border-box;
      /*border-bottom: 1px solid gray;*/
    }
  }

  .el-header {
    /*border-bottom: 1px solid #FF6633;*/
    box-sizing: border-box;
    line-height: 50px;
    padding: 0 0;
  }

  .el-aside {
    height: auto;
    background-color: #ffffff;
    overflow-y: auto;
    -ms-overflow-style: none; /* Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none; /* WebKit */
    }
  }

  .orangev-btn {
    color: white;
    border-color: #FF6633;
    background-color: #FF6633;
  }
}
</style>
